import { VALIDATION_MAP } from "../constants/customValidationMap";
/**
 * Takes and array of strings, then checks if those strings exist as keys in the
 * validation map and returns all the validation functions that exist
 * @param arr of validation keys
 * @returns object of validation functions
 */
export var mapValidation = function (arr) {
    return arr.reduce(function (acc, curr) {
        if (VALIDATION_MAP[curr]) {
            acc[curr] = VALIDATION_MAP[curr];
        }
        return acc;
    }, {});
};
